import axios, { AxiosInstance, AxiosRequestConfig } from "axios"
import CryptoJS from "crypto-js"
import moment from "moment"

const isProd = process.env.GATSBY_FIREBASE_ENV === "production"

type PlainObject = Record<string, any>

class ClientCryptoMiddleware {
  secretKey: string

  constructor(secretKey: string) {
    this.secretKey = secretKey
  }

  handleEncryption = (data: PlainObject): PlainObject => {
    const payload = {
      ...data,
      baseSignDate: moment().utc().format(),
    }

    try {
      const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(payload),
        this.secretKey
      ).toString()

      return { sign: encrypted }
    } catch (err) {
      return data
    }
  }
}

const securityToken = isProd
  ? process.env.GATSBY_SECURITY_PROD_TOKEN
  : process.env.GATSBY_SECURITY_DEV_TOKEN

const cryptoMiddleware = new ClientCryptoMiddleware(securityToken || "")

const AUTH_ENDPOINTS = ["/api/otp/send", "/api/otp/verify"]

const requiresSigning = (url: string): boolean => {
  return AUTH_ENDPOINTS.some(endpoint => url.includes(endpoint))
}

export const createSignedAxios = (): AxiosInstance => {
  const instance = axios.create({
    withCredentials: true,
  })

  instance.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      if (
        config.url &&
        requiresSigning(config.url) &&
        securityToken &&
        config.data
      ) {
        config.data = cryptoMiddleware.handleEncryption(
          config.data as PlainObject
        )
      }
      return config
    },
    error => Promise.reject(error)
  )

  return instance
}

export const signedAxios = createSignedAxios()
